import { QuestionStatus } from './enums';

/** A root waiting for enrichment, or past it and neither retired nor replaced. */
export const ENRICHABLE_QUESTION_STATUSES: readonly QuestionStatus[] = [
  QuestionStatus.ReadyForEnrichment,
  QuestionStatus.AwaitingReview,
  QuestionStatus.Published,
];
